namespace TabAurous.Sales {
    export namespace CustomerSalesService {
        export const baseUrl = 'Sales/CustomerSales';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomerList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function TotalSalesList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/CustomerSales/List",
            CustomerList = "Sales/CustomerSales/CustomerList",
            TotalSalesList = "Sales/CustomerSales/TotalSalesList",
            PartyList = "Sales/CustomerSales/PartyList"
        }

        [
            'List', 
            'CustomerList', 
            'TotalSalesList', 
            'PartyList'
        ].forEach(x => {
            (<any>CustomerSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
